// extracted by mini-css-extract-plugin
module.exports = {"ant-spin-container":"RecognizedSong_ant-spin-container__3cvbB","song":"RecognizedSong_song__1_Os_","closeButton":"RecognizedSong_closeButton__2v8Et"};